<template>
  <div class="charge">
    <Loading v-show="loading"></Loading>
    <h1>ご登録手続き</h1>
    <a href="/plan"><img id="close" src="../../assets/close.png" alt=""></a>
    <div id="tab">
      <ul class="tabMenu">
        <li class="tabItem" v-for="(tab,index) in tabs" v-on:click="activetab=(index+1)" v-bind:class="[ activetab === (index+1) ? 'active' : '' ]">{{tab.tabitem}}</li>
      </ul>
      <div v-if="activetab === 1">
        <p class="caution-text">現在インスタグラムでは登録できません。メールアドレスで登録をお願い致します！</p>
      </div>
      <div class="form" v-else>
        <p class="title">ユーザーネーム</p>
        <input v-model="name" placeholder="例）ジョンソン" autofocus>
        <label>マイページなどに表示される名前</label>
        <p class="title">メールアドレス</p>
        <input type="email" v-model="mail" placeholder="例）calorie@gmail.com">
        <label>ログインIDとして利用</label>
        <p class="title">パスワード</p>
        <input type="password" v-model="password" id="password" placeholder="例）2700abcd">
        <div style="text-align:left;"><input type="checkbox" style="width:auto;" v-model="isCheckedPasword" v-on:change="checkPasword">パスワードを表示する</div>
        <label>ログイン時のパスワード(任意の英数字)</label>
        <p class="title">パスワード確認用</p>
        <input type="password" v-model="confirmPassword" id="confirm-password" placeholder="例）2700abcd">
        <div style="text-align:left;"><input type="checkbox" style="width:auto;" v-model="isCheckedConfirmPasword" v-on:change="checkConfirmPasword">パスワード確認用を表示する</div>
        <label>上記で入力したパスワードを入力</label>
        <p class="title">Instagramアカウント名</p>
        <input type="text" v-model="account" placeholder="例）2700kcal_recipe">
        <label><span class="bold">アカウント情報を記載いただいた方にはInstagramのDMにてレシピや買い物リストを配信<br>※登録後マイページからも設定可能</span></label>
        <div><p style="line-height: 64px;">お支払い情報を入力</p></div>
        <formfield id="ccn">
          <label for="ff1_input">カード番号</label>
          <input id="ff1_input" type="text" maxlength="4" placeholder="1234" name="cno" v-model="cardnum1"/>
          <input type="text" maxlength="4" placeholder="5678" v-model="cardnum2" name="cno"/>
          <input type="text" maxlength="4" placeholder="9012" v-model="cardnum3" name="cno"/>
          <input type="text" maxlength="4" placeholder="3456" v-model="cardnum4" name="cno"/>
        </formfield>
        <formfield id="ch">
          <label for="ff2_input">名前</label>
          <input id="ff2_input" type="text" v-model="cardname1" placeholder="姓"/>
          <input type="text" v-model="cardname2" placeholder="名"/>
        </formfield>
        <formfield id="ed">
          <label>有効期限</label>
          <select v-model="exp_month" id="month">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
          <select v-model="exp_year" id="year">
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
            <option value="2031">2031</option>
            <option value="2032">2032</option>
            <option value="2033">2033</option>
            <option value="2034">2034</option>
            <option value="2035">2035</option>
            <option value="2036">2036</option>
            <option value="2037">2037</option>
            <option value="2038">2038</option>
            <option value="2039">2039</option>
            <option value="2040">2040</option>
          </select>
        </formfield>
        <formfield id="sc">
          <label for="ff4_input">CVC番号</label>
          <input v-model="cvc" id="ff4_input" type="text" maxlength="3" placeholder="CVC"/>
        </formfield>
         <br>
          <br>
        <table style="margin-top:5%;">
          <tbody>
            <tr v-if="plan === 0">
              <td class="key">年間PLAN</td>
              <td class="value">¥ 1500/年(税抜)<br><span>¥ 125/月(税込)</span></td>
            </tr>
            <tr v-else-if="plan === 1">
              <td class="key">月額PLAN</td>
              <td class="value">¥ 180/月(税込)<br></td>
            </tr>
          </tbody>
        </table>
        <div style="height:200px;">
          <label style="text-align:center;" class="privacy"><a href="/">利用規約</a>と<a href="/">プライバシーポリシー</a>に同意して、</label>
      <button id="payButton" type="" v-on:click="pay()">クレジットカードで支払い</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
*{
  box-sizing: border-box;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 40%;
  margin: 16px auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid black;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: black;
  color: #fff;
}
.key{
  width: 30%;
  background:black;
  color: white;
}
table{
  border-spacing: 0px;
  width: 100%;
  border: 1px solid black;
}
table tr{
  height: 80px;
}
.caution-text{
  font-family: Hiragino Kaku Gothic Pro;
  text-align: center;
}
.value{
  font-size: 24px;
  font-weight: bold;
}
span{
  font-size: 12px;
  font-weight: normal;
  font-family: Hiragino Kaku Gothic Pro;
}
.charge{
  position: relative;
}
#close{
  position: absolute;
  top:0%;
  left:20%;
}
.form .title{
  margin-top: 5%;
  text-align: left;
}
.form input{
  width: 100%;
  padding:8px;
  font-size: 24px;
}
.form label{
 font-size: 12px;
 text-align: left;
 width: 100%;
 display: block;

}
.form table{
  margin-top: 5%;
  margin-bottom: 5%;
}
.bold{
  font-weight: bold;
}
.privacy{
  font-size: 12px;
  color: black;
}
.privacy a{
  color: black;
  text-decoration: underline;
}
#payButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:5% auto;
  border:0px;
  width: 100%;
}
@media ( max-width : 600px ){
  h1{
    font-size: 18px;
  }
  #tab{
  max-width: 100%;
  margin: 16px auto;
}
#close{
  position: absolute;
  top:8px;
  left:5%;
  width: 16px;
}
#tab li{
  font-size: 12px;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.form{
 margin-left: 16px;
 margin-right: 16px;
}
#payButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
}
.form input[data-v-4c82ff2f] {
    width: 100%;
    padding: 8px;
    font-size: 14px;
}
}
formfield {
  float: left;
  width: 100%;
}

label {
  float: left;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6em;
  margin-bottom: 5px;
  color: #92A3A6;
}

input, select, button {
  float: left;
  background: transparent;
  border: 2px solid #EBEBEB;
  border-radius: 3px;
  padding: 5px 10px;
  margin: 0 10px 10px 0;
  font-size: 1.2em;
  line-height: 2em;
  transition: border 300ms ease-in;
}

input:focus, select:focus {
  border-color: #20A8FF;
}

input::-webkit-input-placeholder {
  color: rgba(146,163,166,.5);
}


#ccn input[type="text"] {
  width: calc(25% - 10px);
  letter-spacing: 2px;
  text-align: center;
}

#ch input[type="text"] {
  width: calc(50% - 10px);
  text-align: start;
}

#ed, #sc {
  width: 50%;
}

#sc input[type="text"] {
  width: calc(100% - 10px);
}

#ed select {
  background: #fff;
  height: 46px;
  width: calc(50% - 10px);
  line-height: 2em;
  text-align: center;
  font-size: 14px;
}

#cc {
  width: 50%;
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'

export default {
  name: 'Plan',
  components: {
    Loading
  },
  data () {
    return {
      db: null,
      loading: false,
      isChecked: false,
      isCheckedPasword: false,
      isCheckedConfirmPasword: false,
      plan: 1,
      payType: 0,
      activetab: 2,
      name: null,
      mail: null,
      tokId: null,
      password: null,
      confirmPassword: null,
      account: null,
      cardnum1: null,
      cardnum2: null,
      cardnum3: null,
      cardnum4: null,
      number: null,
      cardname1: null,
      cardname2: null,
      cardname: null,
      cvc: null,
      exp_month: null,
      exp_year: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
      halfsizePattern: /^[A-Za-z0-9]*$/,
      halfNumsizePattern: /^[0-9]*$/,
    tabs: [
      { tabitem: "Instagramで登録" },
      { tabitem: "メールアドレスで登録" }
    ],
    contents: [
      {
        position: 0
      },
      {
        position: 1
      }
    ]
    }
  },
  methods: {
    checkPasword: function () {
      var pw = document.getElementById('password')
      if(this.isCheckedPasword) {
        pw.setAttribute('type', 'text')
      } else {
        pw.setAttribute('type', 'password')
      }
    },
    checkConfirmPasword: function () {
      var pw = document.getElementById('confirm-password')
      if(this.isCheckedConfirmPasword) {
        pw.setAttribute('type', 'text')
      } else {
        pw.setAttribute('type', 'password')
      }
    },
    pay: function () {
      // Flaskでトークン作成&顧客カード作成＆決済
      let self = this
      // 入力をチェック
      if (!this.name) {
        alert('名前を入力してください。')
        return
      }
      if (!this.mail) {
        alert('メールアドレスを入力してください。')
        return
      }
      if (!this.mailPattern.test(this.mail)) {
        alert('メールアドレスの入力が正しくありません。')
        return
      }
      if (!this.password) {
        alert('パスワードを入力してください。')
        return
      }
      if (!this.halfsizePattern.test(this.password)) {
        alert('パスワードの入力が正しくありません。パスワードは半角英数字で入力してください。')
        return
      }
      if (!this.confirmPassword) {
        alert('確認用パスワードを入力してください。')
        return
      }
      if (!this.halfsizePattern.test(this.password)) {
        alert('確認用パスワードの入力が正しくありません。確認用パスワードは半角英数字で入力してください。')
        return
      }
      if (!this.password === this.confirmPassword) {
        alert('パスワードと確認用パスワードの入力が一致しません。')
        return
      }

      // クレジットカード情報
      if (!this.cardnum1 || !this.cardnum2 || !this.cardnum3 || !this.cardnum4) {
        alert('カード番号を入力してください。')
        return
      }
      if (!this.halfNumsizePattern.test(this.cardnum1) || !this.halfNumsizePattern.test(this.cardnum2) || !this.halfNumsizePattern.test(this.cardnum3) || !this.halfNumsizePattern.test(this.cardnum4)) {
        alert('カード番号は半角数字で入力してください。')
        return
      }
      this.number = this.cardnum1 + this.cardnum2 + this.cardnum3 + this.cardnum4

      if (!this.cardname1 || !this.cardname2) {
        alert('カードの名義人の名前を入力してください。')
        return
      }
      this.cardname = this.cardname1 + this.cardname2

      if (!this.exp_month) {
        alert('カードの有効期限月を入力してください。')
        return
      }
      if (!this.exp_year) {
        alert('カードの有効期限年を入力してください。')
        return
      }
      if (!this.cvc) {
        alert('CVC番号を入力してください。')
        return
      }
      if (!this.halfNumsizePattern.test(this.cvc) ) {
        alert('CVC番号は半角数字で入力してください。')
        return
      }
      // 既に登録されているアドレスなのかどうか？
      var exist = false
      this.db.collection("users").where("mail", "==", this.mail)
        .get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // self.loading = true
                exist = true
                alert('既に入力されたメールアドレスは登録がされています。既に登録済みの方はページ上部のログインをして、サービスをご使用いただけます。')
                return
            })
            if (!exist) {
              self.loading = true

              // 課金プラン
              var planId = ''
              if (self.plan === 0) {
                planId = 'yearly'
              } else {
                planId = 'monthly'
              }
              var data = {'mail': self.mail, 'name': self.name, 'planId': planId , 'number' : self.number, 'cvc' : self.cvc, 'exp_month' : self.exp_month, 'exp_year' : self.exp_year, 'account' : self.account, 'cardName': self.cardname}
              $.ajax({
                url: 'https://weart-marketing.com/api/7200kcal/subscriptionPayWithToken/',
                type: 'POST',
                data: data
              })
              .done(function (data) {
                // 購買情報と顧客情報を保存
                console.log('ここでサブスクリプションの結果を参照')
                console.log(data)
                var dataArray = data.split(',');
                console.log(dataArray)
                console.log(dataArray[0])
                console.log(dataArray[1])
                self.saveToUserClass(dataArray)
              })
              .fail(function (error) {
                self.loading = false
                alert('購入に失敗しました、カード情報が正しいか再度チェックしてから、ご購入の手続きをお願い致します。')
              })
            }
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        })
    },
    saveToUserClass: function (data) {
      let self = this
      var userDoc = {
          name: this.name,
          mail: this.mail,
          payType: this.payType,
          password: this.password,
          customer: data[0],
          subscription: data[1],
          date: Date()
        }
        let collection = this.db.collection('users')
        collection.add(userDoc).then(function (docRef) {
          // self.loading = false
          // UseIDを用いてログイン状態とする
          console.log(docRef.id)
          localStorage.userId = docRef.id
          // IDを引数で渡して、購買完了ページへ
          location.href = '/success?userId=' + docRef.id

        }).catch(function (error) {
          alert('決済は完了しましたが、顧客情報の登録に失敗しました。運営会社(03-6281-8764)まで連絡してください。')
          self.loading = false
        })
    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.plan = Number(result['plan'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charge/Charge.vue